<template>
  <div>
    <template>
      <div>
        <BaseBusiness :formParams='formParamsBase' ref="base" :opCode="opCode" :funcOnChange ='bindOnChangeInterface'></BaseBusiness>
      </div>
    </template>
    <SubTabs :elements="tabs.elements" :styles='tabs.styles'>
      <template v-slot:tabsContent>
        <div style="margin-top: 15px;">
          <VoiceBusiness :formParams='formParamsVoice' ref="voice" :info='voiceBusinessInfo' :gmsInfo='voiceBusinessInfoGroup' :opCode="opCode"></VoiceBusiness>
        </div>
        <div style="margin-top: 15px;">
          <DataBusiness :formParams='formParamsData' ref="data" :info='dataBusinessInfo' :gmsInfo='dataBusinessInfoGroup' :opCode="opCode"></DataBusiness>
        </div>
        <div style="margin-top: 15px;">
          <VideoBusiness :formParams='formParamsVideo' ref="video" :info='videoBusinessInfo' :gmsInfo='videoBusinessInfoGroup' :opCode="opCode"></VideoBusiness>
        </div>
      </template>
    </SubTabs>
    <CustomDialog ref='qryVpnInfoPage' :element='dialog.eleQryVpnInfo' :styles='dialog.stylesWithIndex'>
      <template v-slot:dialog-content>
        <OrganizationalTree ref="organizationalTreeInner" :neid="gmsNeid" :vpndata="vpndata" :disableNodes="disableNode"></OrganizationalTree>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import BaseBusiness from '../U_BaseBusiness';
import VoiceBusiness from '../U_VoiceBusiness';
import DataBusiness from '../U_DataBusiness';
import VideoBusiness from '../U_VideoBussiness';
import SubTabs from '../../../../subscriberconfig/util/SubTabs';
import SubscriberTool from '../../../../subscriberconfig/util/parseFormNew/tools/subscriberTool';
import commonJs from '../../common';
import CustomDialog from '../../../../common/CustomDialog';
import OrganizationalTree from '../../OrganizationalTree';

export default {
  name: 'AddUserDialog',
  components: {
    SubTabs,
    BaseBusiness,
    VoiceBusiness,
    DataBusiness,
    VideoBusiness,
    CustomDialog,
    OrganizationalTree
  },
  mixins: [commonJs],
  props: [
    'opCode',
    'neid',
    'gmsNeid',
  ],
  methods: {
    mainHandler(data = []) {
      const $this = this;
      let arrBase = null;
      let arrVioce = null;
      let arrData = null;
      let arrVideo = null;
      const params = {
        msgid: this.msg.addUser,
        neid: this.neid,
        serviceType: 'microPoc'
      };
      // $this.$loading.showLoadding();
      $this.voiceBusinessInfo = this.setInfo(this.msg.qryUsers);
      $this.dataBusinessInfo = this.setInfo(this.msg.qryUsers);
      $this.videoBusinessInfo = this.setInfo(this.msg.qryUsers);
      $this.voiceBusinessInfoGroup = this.setGroupInfo(this.msg.qryGroups);
      $this.dataBusinessInfoGroup = this.setGroupInfo(this.msg.qryGroups);
      $this.videoBusinessInfoGroup = this.setGroupInfo(this.msg.qryGroups);
      this.$axios.post('/lte/ems/subscriber/mcs/getParamJson', params).then((response) => {
        const res = response.data.resultVal;
        const sub = new SubscriberTool();
        data = this.initAnotherBussinessDatas(data);
        const resultMap = sub.$devideByGroupBy(res, data);
        arrBase = resultMap.get($this.formParamsBase.modelName);
        $this.formParamsBase = arrBase;

        arrVioce = resultMap.get($this.formParamsVoice.modelName);
        $this.formParamsVoice = arrVioce;

        arrData = resultMap.get($this.formParamsData.modelName);
        $this.formParamsData = arrData;

        arrVideo = resultMap.get($this.formParamsVideo.modelName);
        $this.formParamsVideo = arrVideo;
        //修改时，vpnid支持修改
        if (data && data.length === undefined) {
          try{
            const vpntree = $this.$parent.$parent.$refs.eleModUser.$parent.$parent.$parent.$parent.$refs.organizationalTree;
            $this.vpndata = vpntree.initData;
            $this.disableNode = vpntree.disableNode;
          } catch (e) {
            console.log('获取组织架构失败了');
          }
          setTimeout(() => {
            $this.bindClickAfterPageCreated();
          }, 200);
        }
      });
    },

    setInfo(msgid) {
      return {
        neid: this.neid,
        msgid: msgid
      };
    },

    setGroupInfo(msgid) {
      return {
        neid: this.gmsNeid,
        msgid: msgid,
        serviceType: 'microPoc'
      };
    },

    getDatas() {
      const validateReturn = this.$refs.base.validateResult() === false
        ? false : (this.$refs.voice.validateResult() === false
          ? false : (this.$refs.data.validateResult() === false
            ? false : (this.$refs.video.validateResult() === false
              ? false : true)));
      if (!validateReturn) {
        console.log('表单验证不通过');
        return false;
      }
      const map = this.$refs.base.getDatas();
      //vpnId重新赋值
      this.vpnId && map.set('vpnId', this.vpnId);
      const mapVoice = this.$refs.voice.getDatas();
      const mapData = this.$refs.data.getDatas();
      const mapVideo = this.$refs.video.getDatas();
      let returnObj = {};
      Array.from(map).forEach(([key, value]) => {
        returnObj[key] = value;
      });
      Array.from(mapVoice).forEach(([key, value]) => {
        returnObj[key] = value;
      });
      Array.from(mapData).forEach(([key, value]) => {
        returnObj[key] = value;
      });
      Array.from(mapVideo).forEach(([key, value]) => {
        returnObj[key] = value;
      });
      returnObj = this.getAnotherBussiness(returnObj);
      return returnObj;
    },
    getAnotherBussiness(returnObj) {
      returnObj.userNum = [returnObj.userNum];
      returnObj.password = returnObj['password[origin]'];

      const sdslist = () => {
        const list = [];
        for (let i = 0; i < 16; i++) {
          list.push('');
        }
        return list;
      };
      returnObj.sdslist = sdslist();
      return returnObj;
    },
    initAnotherBussinessDatas(datas) {
      datas['password[origin]'] = datas.password;
      datas['password[confirm]'] = datas.password;
      return datas;
    },
    $bindUsertype(key) {
      this.funcMap.set(key, () => {
        setTimeout(() => {
          this.bindClickAfterPageCreated();
        }, 50);
      });
    },
    bindClickAfterPageCreated() {
      // 输入框点击事件----根据name名称找到组件
      const componentArray = this.$refs.base.$children[0].$children;
      console.log(componentArray)
      componentArray.forEach(item => {
        if (item.$refs.vpnId) {
          // 输入框右侧增加"选择超链接"
          const input = document.createElement('A');
          input.onclick = this.getVpnInfo;
          input.className = 'h-subscriber-atag';
          const valueOfAtag = document.createTextNode(this.$t('SubscriberIms.selectVButton'));
          input.appendChild(valueOfAtag);
          item.$refs.vpnId.parentElement.className = 'h-subscriber-div-innerwitha';
          item.$refs.vpnId.parentElement.appendChild(input);
          return null;
        }
        return null;
      });
    },
    /**
     * 组织架构列表查询
     * @param propinfo
     * @param res
     * @returns {*}
     */
    getVpnInfo(propinfo, $this) {
      // 组织架构查询赋值
      this.$refs.qryVpnInfoPage.show();
      console.log('vpndata', this.vpndata);
      this.$refs.organizationalTreeInner.staDoFieldsList = this.vpndata;
      //当前neid转换成gms的neid
      this.$refs.organizationalTreeInner.getOrganizationalTreeWithNeid();
    },
    /**
     * 更新和关闭组织架构
     */
    setChooseVpnInfo(event) {
      if (event.keyCode === 13) {
        return;
      }
      const selectNode = this.$refs.organizationalTreeInner.getNode();
      if (!selectNode) {
        // this.$layer.alert({ msg: this.$t('SubscriberIms.chooseNodeTip') });
        this.$toast('warning', this.$t('SubscriberIms.chooseNodeTip'));
      } else if(selectNode.id.split('_')[2] === '0' || selectNode.id.split('_')[2] === 0) {
        if ( this.$refs.base.$refs.bus.getDatas().get('userType') !== 3 && this.$refs.base.$refs.bus.getDatas().get('userType') !== 5 ){
          //不允许修改到根节点
        this.$toast('warning', this.$t('MCS.vpn0CantAddUser'));
        }
        else {
          this.$refs.organizationalTreeInner.clear();
          this.$refs.qryVpnInfoPage.clear();
          this.$refs.qryVpnInfoPage.close();
          // this.$refs.base.$refs.bus.setData('vpnId', selectNode.text);
          this.vpnId = selectNode.id.split('_')[2];
          this.$refs.base.$refs.bus.setData('vpnId', this.vpnId);
          this.$refs.base.$refs.bus.validateResult(['vpnId']);
        }
      } else {
        this.$refs.organizationalTreeInner.clear();
        this.$refs.qryVpnInfoPage.clear();
        this.$refs.qryVpnInfoPage.close();
        // this.$refs.base.$refs.bus.setData('vpnId', selectNode.text);
        this.vpnId = selectNode.id.split('_')[2];
        this.$refs.base.$refs.bus.setData('vpnId', this.vpnId);
        this.$refs.base.$refs.bus.validateResult(['vpnId']);
      }
    },
    closeQryVpnInfoPage() {
      this.$refs.organizationalTreeInner.clear();
      this.$refs.qryVpnInfoPage.clear();
      this.$refs.qryVpnInfoPage.close();
    },
  },
  data() {
    return {
      funcMap: new Map(),
      tabs: {
        elements: {
          refName: 'xxxxx',
          items: [
            { header: this.$t('MCS.voiceBusiness'), contentKey: 'item1-content' },
            { header: this.$t('MCS.dataBusiness'), contentKey: 'item2-content' },
            { header: this.$t('MCS.videoBusiness'), contentKey: 'item3-content' },
          ]
        },
        styles: {
          heightMode: 'Auto'
        }
      },
      formParamsBase: {
        modelName: 'base',
      },
      formParamsVoice: {
        modelName: 'voice',
      },
      formParamsData: {
        modelName: 'data',
      },
      formParamsVideo: {
        modelName: 'video',
      },
      baseBusinessInfo: '',
      voiceBusinessInfo: '',
      dataBusinessInfo: '',
      videoBusinessInfo: '',
      voiceBusinessInfoGroup: '',
      dataBusinessInfoGroup: '',
      videoBusinessInfoGroup: '',
      dialog: {
        eleQryVpnInfo: {
          target: this.$refs.qryVpnInfoPage,
          refName: 'qryVpninfo',
          buttonGroup: [
            { click: this.closeQryVpnInfoPage, buttonModel: { content: this.$t('SubscriberIms.cancel') }},
            { click: this.setChooseVpnInfo, buttonModel: { content: this.$t('SubscriberIms.confirm'), isPrimary: true }}],
          title: this.$t('SubscriberIms.organization'),
          isClose: true
        },
        stylesWithIndex: {width: '20%', height: '48%',visible: false,model: true, zIndex: 1000,},
      },
      vpndata: [],
      disableNode:[],
      vpnId: undefined,
      gmsNeId: undefined
    };
  },
  computed: {
    bindOnChangeInterface() {
      this.funcMap = new Map();
      this.$bindUsertype('userType');
      return this.funcMap;
    },
  }
};
</script>
